import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import ObjectSelector from 'scoreboard/components/object-selector'
import constants from 'scoreboard/components/constants'
import template from './ancestor-filter.hbs'
import nodeTemplate from 'scoreboard/reports/wizard/common/select-scorecard-nodes.hbs'
import selectAllItemsNode from 'scoreboard/reports/wizard/common/select-all-items-node.hbs'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import CascadeTooltip from 'scoreboard/components/cascade-tooltip'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import TreeActions from 'scoreboard/components/tree-actions'
import i18n from 'scoreboard/components/i18n'
import spotlight from 'scoreboard/components/spotlight'
import Breadcrumbs from 'scoreboard/components/breadcrumbs'
import ancestorFilterMessageCodes from './ancestor-filter-message-codes'
import { ALL_INITIATIVES } from 'scoreboard/initiatives/initiatives-gardener'

const SelectItemFormView = FormView.extend({

	test: function() {
		let err = FormView.prototype.test.apply(this, arguments)
		if (err) return err
		return this.$('.scorecard-table tbody tr').length != 0 ? null :
			i18n.get(ancestorFilterMessageCodes[this.section].noSelectionCode)
	}

})

/* Filter for selection domain items that are tree based. The default context is for
 * scorecards
 */
const SelectItemFilter = Backbone.View.extend({

	events: {
		'click .delete': 'removeDescendant',
		'change input[type=checkbox][name=ancestor]': 'updateDescendant',
		'click .info': 'info'
	},

	className: 'select-scorecards-filter report-filters',

	initialize: function(options = {}) {
		this.options = options
		this.section = this.options.section || constants.SECTION_SCORECARDS

		this.data = _.defaults({}, this.options.data)

		//ensure we have a label map to work with
		this.orgMap =  _.cloneDeep(this.data.orgMetadata || {})
		this.scorecardMap = _.cloneDeep(this.data.metadata || {})
		this.formViewType = SelectItemFormView
		this.formViewType.section = this.options.noSelectionCode
	},

	render: function () {
		let content = $(template(ancestorFilterMessageCodes[this.section]))

		let selectorOpts = {
			section: this.section,
			allowAll: true,
			showProjectSelector: _.get(this.options, 'showProjectSelector', false)
		}
		let snids = Object.keys(this.scorecardMap)
		//if only one id is specified, we'll initialize the tree to that node
		if (snids.length == 1)  {
			selectorOpts.id = snids[0]
		}

		this.objectSelector = new ObjectSelector(selectorOpts)
		content.find('.object-selector-container').append(this.objectSelector.el)
		this.objectSelector.render()
		this.objectSelector.on('success', this.addTreeAction.bind(this))
		this.listenTo(this.objectSelector, 'select', function(item) {
			this.$('.add').prop('disabled', false)
			if (item.id == ALL_INITIATIVES) {
				let selectedOrg = this.objectSelector.selectedOrg()
				item.organizationId = selectedOrg.id
			}
		})

		//#10126 auto select root for certain filters
		if (this.options.autoSelectRoot) {
			let autoSelectRoot = () => {
				let tree = objGardener.tree
				if (!_.isEmpty(tree.root)) {
					let rootId = tree.root.id
					if (tree.options.forest) {
						rootId = tree.root[0].id
					}
					tree.select(rootId, {
						toggleOnSelect: false,
						animate: false,
						silent: true
					})
					this.treeActions.setButtonContent()
				}
			}

			let objGardener = this.objectSelector.objectGardener
			this.objectSelector.on('selectOrg', function(node) {
				this.listenTo(objGardener, 'end', autoSelectRoot)
			}.bind(this))

			this.objectSelector.once('end', autoSelectRoot)
		}

		//add selected nodes
		_.transform(this.orgMap, function(el, v, k) {
			el.append(selectAllItemsNode(_.assign({organizationId: k}, v)))
		}, content.find('tbody'))

		let ancestorKeys = _.keyBy(this.data.ancestorValues)
		_.transform(this.scorecardMap, function(el, v, k) {
			let id = parseInt(k, 10)
			v.cascade = !_.isNil(ancestorKeys[id])
			el.append(nodeTemplate(_.assign({id: k}, v)))
		}, content.find('tbody'))

		this.$el.empty().append(content)
		this.delegateEvents()

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		this.cascadeTooltip = new CascadeTooltip({
			attachTo: this.$('.cascade-help'),
			helpKey: ancestorFilterMessageCodes[this.section].cascadeHelpCode
		})

		formHelper.writeToDom(this.data, this.el)
		this.toggleNoneMessage()
		this.$('.follow-linked').toggleClass('is-not-displayed', !this.options.showFollowLinked)

		return this
	},

	resize: function() {
		this.objectSelector.resize()
	},

	addTreeAction: function() {
		this.treeActions = new TreeActions({
			el: this.objectSelector.objectGardener.el,
			tree: this.objectSelector.objectGardener.tree,
			buttonContent: i18n.get('common.add')
		}).render()
		this.treeActions.on('selected', this.addDescendant.bind(this))
		this.objectSelector.on('search', this.treeActions.onSearch.bind(this.treeActions))
	},

	addDescendant: function(nodeId) {
		let idCell = this.$('.scorecard-id[data-id=' + nodeId + ']')
		if (nodeId == ALL_INITIATIVES) {
			let org = this.objectSelector.selectedOrg()
			idCell = this.$('.organization-id[data-org-id=' + org.id + ']')
		}
		this.treeActions.applyCheckmark()

		// If clicked button is already disabled, or belongs to an already
		// selected node, don't try to add it. Highlight selected item instead.
		if (idCell.length) {
			let row = this.$('tbody tr').has(idCell)
			spotlight(row)
			return
		}

		this._recordSelectedItem(nodeId)
	},

	_recordSelectedItem: function(nodeId) {
		let selectedOrg = this.objectSelector.selectedOrg()
		//#26657 on slow networks, the org tree may not have loaded the initial
		//selected org that the object tree represents, in that case fall back
		//to the org label that was sent in the header when retreving the object tree
		let orgLabel = selectedOrg ? selectedOrg.label : this.objectSelector.objectGardener.tree.organizationLabel
		let item = this.objectSelector.objectGardener.tree.get(nodeId)
		//#16781 enable cascade by default
		let ctxItem = { label: item.label, orgLabel, cascade: true }
		let template = nodeTemplate
		if (item) {
			if (item.id == ALL_INITIATIVES) {
				template = selectAllItemsNode
				this.orgMap[item.organizationId] = ctxItem
			} else {
				this.scorecardMap[item.id] = ctxItem
			}
			let ctx = _.defaults({}, ctxItem, item)
			this.$('.scorecard-table tbody').append(template(ctx))
			this.trigger('change')
		}
		this.toggleNoneMessage()
	},

	removeDescendant: function(e) {
		let node = this.$(e.target).closest('tr')
		let id = this.$(e.target).data('id')
		if (id) {
			delete this.scorecardMap[id]

			// this.treeActions is initialized only if the current gardener
			// has nodes present, and we don't have to worry about removing the
			// checkmark unless this is the case anyway
			this.treeActions?.removeCheckmark(id)
		} else {
			id = this.$(e.target).data('org-id')
			this.treeActions?.removeCheckmark('all-items')
			delete this.orgMap[id]
		}

		node.remove()
		this.toggleNoneMessage()
		this.trigger('change')
	},

	updateDescendant: function(e) {
		let target = this.$(e.target)
		let nodeId = target.data('id')
		this.scorecardMap[nodeId].cascade = target.is(':checked')
	},

	toggleNoneMessage: function () {
		let noSelection = _.isEmpty(this.scorecardMap) && _.isEmpty(this.orgMap)
		this.$('.none-message').toggleClass('is-not-displayed', !noSelection)
		this.$('.scorecard-table').toggleClass('is-not-displayed', noSelection)
	},

	gather: function() {
		let data = formHelper.readFromDom(this.el)

		this.data.values = []
		this.data.ancestorValues = []
		this.data.organizationValues = []
		_.each(this.scorecardMap, (v, k) => {
			let object = v.cascade ? this.data.ancestorValues: this.data.values
			object.push(k)
		})
		_.each(this.orgMap, (v, k) => {
			this.data.organizationValues.push(k)
		})

		this.data.metadata = this.scorecardMap
		this.data.orgMetadata = this.orgMap
		this.data.followLinked = data.followLinked
		return this.data
	},

	info: function(e) {
		this.infoTooltip && this.infoTooltip.remove()
		let id = $(e.currentTarget).closest('tr').find('.scorecard-id').data('id')
		let url = `api/${this.section}/${id}/ancestors`
		$.get(url, ancestors => {
			this.infoTooltip = Breadcrumbs.tooltip({
				target: e.currentTarget,
				objects: ancestors
			})
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.objectSelector, this.covertButtonTooltips,
			this.infoTooltip, this.cascadeTooltip], 'remove')
	}

})

export default SelectItemFilter

SelectItemFilter.__filename__ = 'reports/common/filter/ancestor-filter.js'
